// src/components/Campaign/CampaignSearchBar.jsx
import React, { useEffect, useState } from "react";
import { MdOutlineSearch } from "react-icons/md";

const CampaignSearchBar = ({ title, onSearchClick }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

  // debounce search
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery.trim());
    }, 400);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    onSearchClick(debouncedQuery);
  }, [debouncedQuery]);

  return (
    <div className="sticky top-0 z-10 bg-white shadow-md px-4 sm:px-6 md:px-10 py-4 border-b">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-800">{title}</h1>

        {/* Search Input */}
        <form
          onSubmit={(e) => e.preventDefault()}
          className="w-full md:w-80 relative"
        >
          <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
            <MdOutlineSearch size={22} />
          </span>

          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search campaigns..."
            className="pl-10 pr-10 py-2 w-full border rounded-lg text-sm md:text-base 
                       border-gray-300 focus:ring-2  
                       transition-colors duration-200 outline-none"
          />

          {searchQuery.length > 0 && (
            <button
              type="button"
              onClick={() => setSearchQuery("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
              title="Clear"
            >
              ✕
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default CampaignSearchBar;
